import type { FC } from 'react';
import { Trans } from 'react-i18next';

import { useRouteLoaderData } from '@remix-run/react';
import cn from 'classnames';

import type { RootLoaderData } from '~/root';
import logout from '~/utils/logout';

interface SignedInAsProps {
  className?: string;
}

// Someone refused under one email can sign out here and join with another.
export const SignedInAs: FC<SignedInAsProps> = ({ className }) => {
  const rootData = useRouteLoaderData<RootLoaderData>('root');
  const email = rootData?.subscription?.email;

  if (!email) return null;

  const notYouButton = (
    <button
      key="notYou"
      type="button"
      onClick={() => logout('token')}
      className="underline transition-colors duration-150 hover:opacity-80"
    />
  );

  return (
    <p className={cn('text-[13px] leading-6', className)}>
      <Trans i18nKey="community.join_refused.signed_in_as" values={{ email }} components={{ notYou: notYouButton }} />
    </p>
  );
};
